import { AppDispatch, GetState } from '../store';
import { sdkCallbacks } from '../../features/session/sdk-callbacks';
import { callbackRegistry } from '../../features/session/callback-registry';
import { SessionState } from '../../types/session';
import { BankAuthenticationSuccessData } from '../../services/interfaces/session.interface';
import { startSessionError, startSessionStarted, startSessionSuccess } from '../actions/session.actions';
import { CallbackEvent } from '../../types/sdk';
import { reportError } from '../slices/error.slice';
import { BankIntegrationVendor } from '../../types/bank-integration-vendor';
import { getSessionService } from '../../services/service.factory';

export const startSession = (id: string) => {
	return async (dispatch: AppDispatch, getState: GetState) => {
		dispatch(startSessionStarted());
		try {
			const vendor = getState().configuration.bankIntegrationVendor;
			const sessionState = await getSessionState(id, vendor);
			dispatch(
				startSessionSuccess(
					sessionState || {
						polling: false,
						status: 'CONSUMER_INPUT_NEEDED',
						result: {
							type: 'bank_selection'
						}
					}
				)
			);
			executeCallback('onReady');
		} catch (error: any) {
			dispatch(
				reportError({
					type: 'TECHNICAL',
					reason: { ...error, json: JSON.stringify(error) }
				})
			);

			dispatch(startSessionError());
		}
	};
};

const executeCallback = (event: CallbackEvent) => {
	sdkCallbacks.execute(event);
	callbackRegistry.retrieve(event)();
};

const getSessionState = async (id: string, vendor: BankIntegrationVendor): Promise<SessionState | undefined> => {
	const currentURL: URL = new URL(window.location.href);
	const sessionService = getSessionService(vendor);

	if (isBankRedirect(currentURL)) {
		const URL = currentURL.toString();
		const data: BankAuthenticationSuccessData = { url: URL };
		try {
			return await sessionService.authenticated(id, data);
		} finally {
			stripURL();
		}
	}

	if (vendor === 'FINCREDIBLE') {
		return undefined;
	}

	return await sessionService.getSessionState(id);
};

const isBankRedirect = (URL: URL) => {
	const redirect = URL.searchParams.get('redirect');
	return redirect === 'klarna' || redirect === 'fincredible';
};

const stripURL = () => {
	const URL = window.location.pathname;
	window.history.pushState({}, document.title, URL);
};
